import { Route, Switch, Redirect } from 'react-router-dom';
import React from 'react';
import Home from '../pages/Home';
import Vacancies from '../pages/Vacancies';
import VacancyOverview from '../pages/VacancyOverview';
import VacancyApply from '../pages/VacancyApply';
import Login from '../pages/Login';

const Routes = () => {
	
	return (
		<Switch>
			<Route exact path="/" component={Home}/>
			<Route path="/login" component={Login}/>
			<Route path="/vacancies/:category?" component={Vacancies}/>
			<Route path="/vacancy/:vacancyId/overview" component={VacancyOverview}/>
			<Route path="/vacancy/:vacancyId/apply" component={VacancyApply}/>
			<Redirect from="*" to="/"/>
		</Switch>
	);
};

export default Routes;


// WEBPACK FOOTER //
// ./src/routes/Routes.js